export default {
  about: "About us",
  readMore: "Read more",
};
